import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, FileText } from 'lucide-react';
import { LEGAL_INDEX, LEGAL_UPDATED } from '../data/legalDocuments';

export function LegalHubPage() {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <div className="border-b border-border bg-card/40 backdrop-blur-sm">
        <div className="mx-auto flex max-w-3xl items-center justify-between gap-4 px-6 py-4">
          <Link
            to="/login"
            className="inline-flex items-center gap-2 text-sm text-muted-foreground transition-colors hover:text-primary"
          >
            <ArrowLeft className="h-4 w-4" />
            Back to sign in
          </Link>
        </div>
      </div>
      <div className="mx-auto max-w-3xl px-6 py-12">
        <h1 className="font-heading text-3xl font-bold tracking-tight">Legal &amp; policies</h1>
        <p className="mt-2 text-sm text-muted-foreground">
          Last reviewed: {LEGAL_UPDATED}. These documents support transparency and risk management for the AERTA pilot.
          They are not a substitute for advice from qualified legal counsel.
        </p>
        <ul className="mt-8 grid gap-3">
          {LEGAL_INDEX.map((item) => (
            <li key={item.slug}>
              <Link
                to={`/legal/${item.slug}`}
                className="flex items-start gap-3 rounded-xl border border-border bg-card/60 p-4 transition-colors hover:border-primary/40 hover:bg-card"
              >
                <FileText className="mt-0.5 h-5 w-5 shrink-0 text-primary" aria-hidden />
                <div>
                  <span className="font-medium text-foreground">{item.title}</span>
                  <p className="mt-1 text-sm text-muted-foreground">{item.blurb}</p>
                </div>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
